// extracted by mini-css-extract-plugin
export default {"wrapper":"Wz-z","viewport":"Xz-z","container":"Yz-z","slide":"Zz-z"};